module.exports = __webpack_public_path__ + "static/media/sws-ag.75f9fd9c.png";